/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { PaginationInfoModel, PaginationInfoModelType } from './PaginationInfoModel'
import { PaginationInfoModelSelector } from './PaginationInfoModel.base'
import { UserGamesModel, UserGamesModelType } from './UserGamesModel'
import { UserGamesModelSelector } from './UserGamesModel.base'
import { RootStoreType } from './index'

/**
 * PaginatedUserGamesBase
 * auto generated base class for the model PaginatedUserGamesModel.
 */
export const PaginatedUserGamesModelBase = ModelBase.named('PaginatedUserGames')
  .props({
    __typename: types.optional(types.literal('PaginatedUserGames'), 'PaginatedUserGames'),
    games: types.union(types.undefined, types.array(types.late(() => UserGamesModel))),
    pagination: types.union(
      types.undefined,
      types.late(() => PaginationInfoModel)
    )
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class PaginatedUserGamesModelSelector extends QueryBuilder {
  games(
    builder:
      | string
      | UserGamesModelSelector
      | ((selector: UserGamesModelSelector) => UserGamesModelSelector)
      | undefined
  ) {
    return this.__child('games', UserGamesModelSelector, builder)
  }
  pagination(
    builder:
      | string
      | PaginationInfoModelSelector
      | ((selector: PaginationInfoModelSelector) => PaginationInfoModelSelector)
      | undefined
  ) {
    return this.__child('pagination', PaginationInfoModelSelector, builder)
  }
}
export function selectFromPaginatedUserGames() {
  return new PaginatedUserGamesModelSelector()
}

export const paginatedUserGamesModelPrimitives = selectFromPaginatedUserGames()
